export const getIfExist = elem => (elem ? elem : undefined);

export const isEmptyObject = obj => !obj || !Object.keys(obj).length;
